import { ThemeProvider } from "@bonusx-global/bx-design-system";
import React from "react";

interface BonusXThemeProviderProps {
  children: JSX.Element[] | JSX.Element | React.ReactNode;
}

export function BonusXThemeProvider({ children }: Readonly<BonusXThemeProviderProps>): JSX.Element {
  return <ThemeProvider>{children}</ThemeProvider>;
}
